module.exports = __webpack_public_path__ + "static/img/card1.61da324.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/card1.jpg
// module id = 1cKh
// module chunks = 1